import { defineComponent } from "../../../common/runtime/defineComponent.svelte.ts";
import type { Props } from "./SelectionTileV2.types.js";
import component from "./SelectionTileV2.svelte";

defineComponent<Props>({
  tag: "oc-selection-tile-v2",
  extendOptions: { useOcAutoAriaLabel: true },
  props: {
    variant: { type: "String", reflect: true },
    color: { type: "String", reflect: true },
    imgSrc: { type: "String", attribute: "img-src", reflect: true },
    widthBehavior: { type: "String", attribute: "width-behavior", reflect: true },
    strikeThrough: { type: "Boolean", attribute: "strike-through", reflect: true },
  },
  component: () => component,
  styles: () => import("./SelectionTileV2.global.scss?inline"),
});
